import loadable from '@loadable/component';
import expertLandingPageQuery from './query.graphql';

const ExpertLandingPage = loadable(() =>
  import(/* webpackChunkName: "expert" */ './landing-page')
);

ExpertLandingPage.graphQL = expertLandingPageQuery;

ExpertLandingPage.variables = () => {
  // Configure popular categories here as a temp solution
  return {
    limit: 4,
    popCategories: ['horlurar', 'barnvagnar', 'mobiltelefoner', 'schampo'],
  };
};

export default ExpertLandingPage;
